import { Placeholder } from 'rsuite';

const RedditUserLoader = () => (
	<>
		{new Array(50).fill(null).map((_, idx) => (
			<div
				key={idx}
				className="flex h-[82px] items-center border-b border-gray-200"
			>
				<div className="flex-1 px-[8px] flex gap-[16px] items-center">
					<Placeholder.Graph
						active
						className="!h-[40px] !w-[40px] !min-w-[40px] !rounded-full"
					/>

					<Placeholder.Graph
						active
						className="!h-[16px]"
					/>
				</div>

				<div className="w-[215px] px-[8px] flex items-center gap-[8px]">
					<Placeholder.Graph
						active
						className="!h-[16px] !w-[16px] !rounded-full"
					/>

					<Placeholder.Graph
						active
						className="!h-[16px]"
					/>
				</div>

				<div className="w-[250px] px-[8px]">
					<Placeholder.Graph
						active
						className="!h-[16px]"
					/>
				</div>

				<div className="w-[100px] flex items-center justify-end px-[8px]">
					<Placeholder.Graph
						active
						className="!h-[16px] !w-[24px]"
					/>
				</div>

				<div className="w-[170px] px-[12px] flex items-center">
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full"
					/>
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
					/>
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
					/>
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
					/>
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
					/>
					<Placeholder.Graph
						active
						className="!h-[32px] !w-[32px] !min-w-[32px] !rounded-full ml-[-10px]"
					/>
				</div>

				<div className="w-[70px] flex items-center justify-center">
					<Placeholder.Graph
						active
						className="!h-[16px] !w-[16px] !rounded-full"
					/>
				</div>
			</div>
		))}
	</>
);

export default RedditUserLoader;
